module.exports = __webpack_public_path__ + "img/bg.d4b8965c.png";